import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import routesArray from './routes-array';

function Sidebar() {
  const getInitials = (label) => {
    if (!label) return "";

    const words = label.trim().split(" ");
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }

    return (
      words[0].charAt(0).toUpperCase() +
      words[1].charAt(0).toUpperCase()
    );
  }

  return (
    <div className="">
      <img
        className="light"
        alt="ITC"
        src={logo}
        width="55"
      />
      <div className="position-sticky pt-3 pb-5 sidebar-sticky">
        <ul className="side-nav">
          {routesArray?.map((item, index) => {
            const initials = getInitials(item?.name);
            const val = index + 1;
            return (
              <li key={val}>
                <NavLink to={item.path} className="nav-link">
                  <div className="initials-circle">{initials}</div>
                  {/* <i className={item.icon ? item.icon : ''} style={{ width: '24px' }}></i>  */}
                  <div className='icon_text_space'>{item.name}</div>
                </NavLink>
              </li>)
          })}
        </ul>
        <p className='footer_text'>© ITC Limited {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}
export default Sidebar;